namespace TotalPoll {
    import Component = TotalCore.Common.Component;
    import ILocationService = angular.ILocationService;
    import Processable = TotalCore.Common.Processable;
    import RepositoryService = TotalPoll.RepositoryService;

    @Component('components.totalpoll', {
        templateUrl: 'log-browser-component-template',
        bindings: {}
    })
    class LogBrowserComponent extends Processable {
        public columns = {
            'status': true,
            'action': true,
            'date': true,
            'ip': true,
            'poll': true,
            'user_id': false,
            'user_login': false,
            'user_name': true,
            'user_email': false,
            'browser': true,
        };
        public currentItem = null;
        public currentItemIndex = null;
        public currentPage = 1;
        public filters: any = {};
        public items = [];
        public labels = {
            'user': 'User',
            'sentVia': 'Sent via',
            'env': 'Environment',
        };
        public lastPage = true;

        constructor(private $scope, private RepositoryService: RepositoryService, private $location: ILocationService) {
            super();
            let urlParams = $location.search();

            this.currentPage = Math.abs(Number(urlParams['current']) || 1);
            this.filters.from = urlParams['from'] || null;
            this.filters.to = urlParams['to'] || null;
        }

        $onInit() {
            this.loadPage(this.currentPage);
            jQuery(document).on('keyup', (evt) => {
                this.$scope.$apply(() => {
                    if (evt.keyCode == 27) {
                        this.closeModal();
                    } else if (evt.keyCode == 37) {
                        this.previousItem();
                    } else if (evt.keyCode == 39) {
                        this.nextItem();
                    }
                });
            });
        }

        canExport() {
            return this.items.length > 0;
        }

        closeModal() {
            this.currentItem = null;
        }

        exportAs(format) {
            this.RepositoryService.getDownload(format, this.filters);
        }

        hasNextItem() {
            if (this.currentItem) {
                const currentIndex = this.items.indexOf(this.currentItem);

                return currentIndex + 1 < this.items.length;
            }
            return false;
        }

        hasNextPage() {
            return !this.lastPage;
        }

        hasPreviousItem() {
            if (this.currentItem) {
                return this.currentItemIndex - 1 >= 0;
            }

            return false;
        }

        hasPreviousPage() {
            return this.currentPage != 1;
        }

        isFirstPage() {
            return this.currentPage === 1;
        }

        isLastPage() {
            return this.lastPage;
        }

        isModalOpen() {
            return this.currentItem;
        }

        isPage(page) {
            return this.currentPage == page;
        }

        loadPage(page: number) {
            this.startProcessing();
            this.RepositoryService
                .getPage(page, this.filters)
                .then((response) => {
                    this.currentPage = page;
                    this.items = response['entries'];
                    this.lastPage = response['lastPage'];
                    this.updateUrl();
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadPage(page);
                    }
                })
                .finally(() => {
                    this.stopProcessing();
                });
        }

        nextItem() {
            if (this.hasNextItem()) {
                this.currentItemIndex++;
                this.currentItem = this.items[this.currentItemIndex];
            }
        }

        nextPage() {
            this.loadPage(this.currentPage + 1);
        }

        openItem(item) {
            this.currentItem = item;
            this.currentItemIndex = this.items.indexOf(item);
        }

        previousItem() {
            if (this.hasPreviousItem()) {
                this.currentItemIndex--;
                this.currentItem = this.items[this.currentItemIndex];
            }
        }

        previousPage() {
            this.loadPage(this.currentPage - 1);
        }

        resetFilters() {
            this.filters.from = null;
            this.filters.to = null;
            this.loadPage(1);
        }

        updateUrl() {
            this.$location.search(angular.extend({}, this.$location.search(), this.filters, {current: this.currentPage}));
        }
    }

}
